import React from 'react'
import cx from 'classnames'

import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { DropdownAnchor } from '../ActionsDropdown/common/DropdownAnchor/DropdownAnchor'
import { DropdownMenu } from './common/DropdownMenu/DropdownMenu'
import { FilterIcon } from 'components/shared/Icon/Icon'
import styles from './FilterDropdown.module.scss'
import * as R from 'ramda'

export const FilterDropdown = ({ setFilter, filter, filtersConfig, size }) => (
  <Dropdown hasArrow>
    <DropdownAnchor
      ariaLabel="filter"
      className={cx(styles.filterButton, {
        [styles.active]: filtersConfig.some(conf => filter[conf.key]),
      })}
      icon={FilterIcon}
      {...{ size }}
    />
    <DropdownMenu
      onClick={setFilter}
      filter={filter}
      filtersConfig={filtersConfig}
    />
  </Dropdown>
)
